/**
 * TOPO (Topo) Module Seeds - Consolidated Index
 *
 * Phase H-7: Migrated from flat seed_TOPO.json to folder-based pattern.
 */

import topoEuFysisch from './TOPO-EU-FYSISCH.json'
import topoEuLand from './TOPO-EU-LAND.json'
import topoKlimaat from './TOPO-KLIMAAT.json'
import topoNlProv from './TOPO-NL-PROV.json'
import topoNlWater from './TOPO-NL-WATER.json'
import topoNlBuurlanden from './TOPO-NL-BUURLANDEN.json'
import topoWereldCont from './TOPO-WERELD-CONT.json'

// REMOVED: TOPO-KAART-COOR.json — familyId not in taxonomy (removed in MVP: custom UI)

const TOPO_FAMILY_SEEDS = [
  { file: 'src/data/seeds/TOPO/TOPO-EU-FYSISCH.json', data: topoEuFysisch },
  { file: 'src/data/seeds/TOPO/TOPO-EU-LAND.json', data: topoEuLand },
  { file: 'src/data/seeds/TOPO/TOPO-KLIMAAT.json', data: topoKlimaat },
  { file: 'src/data/seeds/TOPO/TOPO-NL-PROV.json', data: topoNlProv },
  { file: 'src/data/seeds/TOPO/TOPO-NL-WATER.json', data: topoNlWater },
  {
    file: 'src/data/seeds/TOPO/TOPO-NL-BUURLANDEN.json',
    data: topoNlBuurlanden,
  },
  { file: 'src/data/seeds/TOPO/TOPO-WERELD-CONT.json', data: topoWereldCont },
] as const

const allQuestions = TOPO_FAMILY_SEEDS.flatMap(({ file, data }) =>
  data.questions.map((question: any) => ({ ...question, __sourceFile: file })),
)

export default {
  module: 'Topo' as const,
  moduleCode: 'TOPO',
  version: '5.2-modular',
  taxonomyVersion: '4.1',
  questions: allQuestions,
}
